import FlashLib from 'flashlib_onlyplay';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../enums/eAnimationTypes';

export default class ControllerSlotFront extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    // this.init();
  }

  // init() {
  //   this.frameAnimation = animationCreator.createAnimation(eAnimationTypes.BACKGROUND);
  //   this.frameAnimation.state.setAnimation(0, 'idle', true);
  //   this.frameAnimation.visible = true;
  //
  //   const animationPlace = this.getChildByName('animationPlace');
  //   animationPlace.addChild(this.frameAnimation);
  // }
  //
  // playWinAnimation() {
  //   this.frameAnimation.state.setAnimation(0, 'win', false);
  //   this.frameAnimation.state.addAnimation(0, 'idle', true, 0);
  // }
}
